/*import axios from 'axios';*/

import {
  cnxAPI,
  notifica,
  show_ldr,
  getIdUsuario,
  cnxSeg,
  getToken,
} from "./utils";

import axios from "axios";

const getUsuarios = async (_callback) => {
  show_ldr(true);
  let response = await axios.get(`${cnxAPI}User/getUser`).then((res) => {
    return res.data;
  });
  show_ldr(false);

  return response.data;
};

const deleteUser = async (userId) => {
  show_ldr(true);
  let response = await axios
    .get(`${cnxAPI}User/DeleteUser/${userId}`)
    .then((res) => {
      return res.data;
    });
  notifica(
    "success",
    "Se dio de baja correctamente el usuario",
    "Eliminación de usuario"
  );

  show_ldr(false);
  return response.data;
};

function altaUser(dto) {
  let idUserAct = getIdUsuario(),
    tkn = getToken();
  dto.idUsuarioAct = idUserAct;
  dto.token = tkn;
  console.log(dto);
  let datos = btoa(unescape(encodeURIComponent(JSON.stringify(dto))));

  axios({
    method: "post",
    url: cnxSeg + "users/addUser",
    data: "data=" + datos,
  })
    .then(function (response) {
      if (
        response.data.message.includes("ya se encuentra registrado") ||
        response.data.code === 200
      ) {
        altaApp(
          39,
          response.data.data[0].idUsuario,
          idUserAct,
          tkn,
          dto.idPerfilNegocio
        );
      } else {
        notifica("warning", response.data.message, "Alta Usuario");
      }
    })
    .catch(function (error) {
      console.log(error.response);
      if (error.response) {
        const { data } = error.response;
        let msg = "";
        if (data && data.errors) {
          Object.keys(data.errors).forEach(function (key) {
            msg += `${data.errors[key]} \n`;
          });
        }
        notifica("warning", msg, "Alta Usuario");
      } else {
        notifica("warning", error, "Alta Usuario");
      }
    });
}

//Función para dar de alta la Aplicación al usuario
function altaApp(idApp, idUsuarioNew, idUserAct, tkn, idPerfil) {
  var obj = {
    idAplicacion: idApp,
    idUsuario: idUsuarioNew,
    idUsuarioAct: idUserAct,
    token: tkn,
  };
  let datos = btoa(unescape(encodeURIComponent(JSON.stringify(obj))));
  axios({
    method: "post",
    url: cnxSeg + "users/addApp",
    data: "data=" + datos,
  })
    .then(function (response) {
      if (
        response.data.message.includes("El Registro Seleccionado Ya Existe") ||
        response.data.code === 200
      ) {
        addAmb(idApp, idUsuarioNew, idUserAct, tkn, idPerfil);
      } else {
        notifica("warning", response.data.message, "Alta App " + idApp);
      }
    })
    .catch(function (error) {
      notifica("warning", error, "Alta Aplicación");
    });
}

//Función para dar de alta el Ambiente de la App
function addAmb(idApp, idUsuarioNew, idUserAct, tkn, idPerfil) {
  var amb = 1,
    obj = {
      idAplicacion: idApp,
      idAmbiente: amb,
      idUsuario: idUsuarioNew,
      idUsuarioAct: idUserAct,
      token: tkn,
    };
  let datos = btoa(unescape(encodeURIComponent(JSON.stringify(obj))));
  axios({
    method: "post",
    url: cnxSeg + "users/addAmb",
    data: "data=" + datos,
  })
    .then(function (response) {
      if (
        response.data.message.includes("El Registro Seleccionado Ya Existe") ||
        response.data.code === 200
      ) {
        if (idApp === 6) {
          addOrigen(idApp, idUsuarioNew, idUserAct, tkn, 2, idPerfil);
        } else {
          addOrigen(idApp, idUsuarioNew, idUserAct, tkn, 1, idPerfil);
        }
      } else {
        notifica(
          "warning",
          response.data.message,
          "Alta Ambiente " + amb + " App " + idApp
        );
      }
    })
    .catch(function (error) {
      notifica("warning", error, "Alta Ambiente");
    });
}

//Función para dar de alta el Origen de la App
function addOrigen(idApp, idUsuarioNew, idUserAct, tkn, idOrig, idPerfil) {
  var obj = {
    idAplicacion: idApp,
    idOrigen: idOrig,
    idUsuario: idUsuarioNew,
    idUsuarioAct: idUserAct,
    token: tkn,
  };
  let datos = btoa(unescape(encodeURIComponent(JSON.stringify(obj))));
  axios({
    method: "post",
    url: cnxSeg + "users/addOrigen",
    data: "data=" + datos,
  })
    .then(function (response) {
      if (
        response.data.message.includes("El Registro Seleccionado Ya Existe") ||
        response.data.code === 200
      ) {
        //addOrigen(idApp, idUsuarioNew, idUserAct, tkn, 1);
        altaUsuarioNegocio(idUsuarioNew, idUserAct, idPerfil);
      } else {
        notifica(
          "warning",
          response.data.message,
          "Alta Origen " + idOrig + " App " + idApp
        );
      }
    })
    .catch(function (error) {
      notifica("warning", error, "Alta Origen _");
    });
}

//Función para registrar el Usuario, Proyectos, Cedis y Marcas
function altaUsuarioNegocio(idUsuario, idUserAct, idPerfil) {
  let dto = {
    IdUsuario: idUsuario,
    IdUsuarioAct: idUserAct,
    IdPerfil: idPerfil,
  };
  axios({
    method: "post",
    url: cnxAPI + "User/UpdateUsuarios",
    data: dto,
  })
    .then(function (response) {
      if (response.data.code === 0) {
        notifica(
          "info",
          "Se asignaron correctamente los permisos",
          "Alta Negocio"
        );
      } else {
        notifica("warning", response.data.message, "Alta Negocio");
        //show_mdl_ldr(false);
      }
    })
    .catch(function (error) {
      notifica("warning ", error, "Alta Usuario Negocio");
    });
}

const updateUser = async (dto) => {
  show_ldr(true);
  let response = await axios
    .post(`${cnxAPI}User/updateUser`, dto)
    .then((res) => {
      return res.data;
    });
  notifica("success", "Se actualizo correctamente el usuario", "éxito");

  show_ldr(false);
  return response.data;
};

export { getUsuarios, altaUser, deleteUser, updateUser };
